<template>
  <!-- default width="40" height="40" -->
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M2.81177 2.81177C0 5.62355 0 10.149 0 19.2V20.8C0 29.851 0 34.3764 2.81177 37.1882C5.62355 40 10.149 40 19.2 40H20.8C29.851 40 34.3764 40 37.1882 37.1882C40 34.3764 40 29.851 40 20.8V19.2C40 10.149 40 5.62355 37.1882 2.81177C34.3764 0 29.851 0 20.8 0H19.2C10.149 0 5.62355 0 2.81177 2.81177ZM6.75018 12.1667C6.96685 22.5667 12.1668 28.8167 21.2834 28.8167H21.8003V22.8667C25.1503 23.2001 27.6833 25.6501 28.7 28.8167H33.4335C32.1335 24.0834 28.7167 21.4667 26.5833 20.4667C28.7167 19.2334 31.7167 16.2334 32.4333 12.1667H28.1333C27.1999 15.4667 24.4336 18.4667 21.8003 18.7501V12.1667H17.5001V23.7001C14.8334 23.0334 11.4669 19.8001 11.3168 12.1667H6.75018Z"
    fill="black" />
</template>

<script>
export default {
  name: 'IconVK',
}
</script>
